import { motion } from "framer-motion";
import { WhatsAppIcon, PhoneIcon } from "./icons";
import { waLink, telLink } from "@/config";

export const StickyMobileBar = () => (
  <motion.div
    initial={{ y: 80 }}
    animate={{ y: 0 }}
    transition={{ duration: 0.7, delay: 0.9, ease: [0.22, 1, 0.36, 1] }}
    className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-md border-t border-brandSand p-3 flex gap-2"
  >
    <a
      data-testid="sticky-call-btn"
      href={telLink}
      className="flex-1 flex items-center justify-center gap-2 py-3 bg-brandDarkSlate text-white text-xs font-semibold rounded-xl"
    >
      <PhoneIcon className="w-4 h-4" />
      Call
    </a>
    <a
      data-testid="sticky-wa-btn"
      href={waLink()}
      target="_blank"
      rel="noreferrer"
      className="flex-[2] flex items-center justify-center gap-2 py-3 bg-emerald-700 text-white text-xs font-semibold rounded-xl"
    >
      <WhatsAppIcon className="w-4 h-4" />
      Order on WhatsApp
    </a>
  </motion.div>
);
